<template>
  <div>
    <navigation />
    <div class="match-task-list-container">
      <el-table :data="matchTaskList" style="width: 100%">
        <el-table-column prop="id" label="任务ID" align="center" width="80"> </el-table-column>
        <el-table-column prop="name" label="任务名称" align="center" min-width="120"> </el-table-column>
        <el-table-column prop="desc" label="描述" align="center" min-width="140">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="scope.row.desc" placement="bottom">
              <span>{{ descFormat(scope.row.desc) }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="createAt" label="创建时间" align="center" width="160">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createAt) }}
          </template>
        </el-table-column>
        <el-table-column prop="imageCount" label="图片数量" align="center" width="100"> </el-table-column>
        <el-table-column prop="status" label="状态" align="center" width="120">
          <template slot-scope="scope">
            <i
              style="width:6px;height:6px;border-radius:50%;display:inline-block;vertical-align:middle;margin-right:4px;"
              :style="{ backgroundColor: getStatusColor(scope.row.status) }"
            ></i>
            {{ statusText(scope.row.status) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span
              v-if="Number(scope.row.status) === 1"
              style="color: #5d89c0;cursor: pointer;"
              @click="goAnnotate(scope.row)"
              >标注</span
            >
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :page-size="pageSize"
        :page-index="pageIndex"
        :item-total="itemTotal"
        @changeindex="changePageIndex"
        @changesize="changePageSize"
      />
    </div>
  </div>
</template>

<script>
import navigation from '@/components/navigation';
import * as api from '@/api/api.js';
import pagination from '@/components/pagination';

export default {
  name: 'MatchTaskList',
  components: {
    navigation,
    pagination,
  },
  data() {
    return {
      matchTaskList: [],
      pageSize: 20,
      pageIndex: 0,
      itemTotal: 0,
      statusMap: {
        '0': '未开始',
        '1': '标注中',
        '2': '完成',
      },
    };
  },
  mounted() {
    this.getMatchTaskList();
  },
  methods: {
    getMatchTaskList() {
      api.getMatchTaskList({ p: this.pageIndex, ps: this.pageSize }).then(res => {
        this.matchTaskList = res.data.tasks;
        this.itemTotal = res.data.total;
      });
    },
    goAnnotate(row) {
      this.$router.push({
        path: `/match-task/annotate/${row.id}`,
      });
    },
    descFormat(desc) {
      desc = desc || '-';
      return desc.length > 30 ? desc.slice(0, 30).concat('...') : desc;
    },
    formatDate(dateStr) {
      if (!dateStr) return '-';
      const d = new Date(dateStr);
      const pad = n => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(
        d.getMinutes(),
      )}`;
    },
    statusText(status) {
      return this.statusMap[String(status)] || '-';
    },
    getStatusColor(status) {
      const s = Number(status);
      if (s === 1) return '#5d89c0';
      if (s === 2) return '#70c05d';
      return '#bbbbbb';
    },
    changePageIndex(page) {
      this.pageIndex = page;
      this.getMatchTaskList();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.getMatchTaskList();
    },
  },
};
</script>

<style scoped></style>
